import { useQuery } from 'react-query';
import { 
	ApiError, 
	getAccountsInformationResponse
} from 'src/modules/generated-api-clients/sql';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { useApiSqlContext } from 'src/modules/contexts/ApiSqlContext';

export const useAccountInfoQuery = (accountId?: string) => {
	const { client } = useApiSqlContext();
	const { user } = useAuthenticator(context => [context.user]);
	const token = user.getSignInUserSession()?.getIdToken().getJwtToken();
	return useQuery<getAccountsInformationResponse, ApiError>(
		['accountInfo', accountId, token],
		async () => {
			try {
				if (!client) {
					throw new Error('API client is not initialized');
				}
				if (token === undefined) {
					throw new Error('AWS Amplify user attributes cannot be undefined');
				}
				if (!accountId) {
					throw new Error('Account ID cannot be undefined');
				}
				const response = await client.default.getAdminPortalHomeLandingAccountInformation(
					token,
					accountId
				);
				return response;
			} catch (error: unknown) {
				if (error instanceof ApiError) {
					console.error(
						`ApiError -> URL: ${error.url}\nSTATUS: ${error.status}\nMESSAGE: ${
							error.message
						}\nBODY: ${JSON.stringify(error.body)}`
					);
					throw error;
				} else {
					console.error('Error fetching account information:', error);
					throw error;
				}
			}
		},
		{
			enabled: !!accountId && !!token // Ensure both account_id and email are available
		}
	);
};

// export const useGetAccountInfo = (accountId: string) => {
// 	const { client } = useApiSqlContext();
// 	const { user } = useAuthenticator(context => [context.user]);
// 	const token = user.getSignInUserSession()?.getIdToken().getJwtToken();
// 	return useQuery(
// 		['invoiceAccountId', accountId],
// 		async () => {
// 			try {
// 				if (!client) {
// 					throw new Error('API client is not initialized');
// 				}
// 				if (token === undefined) {
// 					throw new Error('AWS Amplify user attributes cannot be undefined');
// 				}

// 				const response = await client.default.getBackendGetAccountInfo(accountId);
// 				return response;
// 			} catch (error: unknown) {
// 				if (error instanceof ApiError) {
// 					console.error(
// 						`ApiError -> URL: ${error.url}\nSTATUS: ${error.status}\nMESSAGE: ${
// 							error.message
// 						}\nBODY: ${JSON.stringify(error.body)}`
// 					);
// 					throw error;
// 				} else {
// 					console.error('Error fetching account information:', error);
// 					throw error;
// 				}
// 			}
// 		},
// 		{
// 			enabled: !!accountId && !!token // Ensure both account_id and token are available
// 		}
// 	);
// };
